module.exports = "<h2>\r\n  Dashboard will be here\r\n</h2>\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n"


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/modules/dashboard/dashboard.html
 ** module id = 446
 ** module chunks = 0
 **/